import type {
  MediaFileStatus,
  MediaFileType,
  MediaRole,
  MediaRoleCode,
  PublicDeliveryStatus,
  RenditionKind,
} from './media-browser.view-model';

export type MediaAttachmentVersions = Record<string, number>;

export interface RenditionViewModel {
  kind: RenditionKind;
  fileId: number;
  previewUrl: string | null;
  widthPx: number | null;
  heightPx: number | null;
  contentType: string;
}

export interface AttachmentFileViewModel {
  type: MediaFileType;
  status: MediaFileStatus;
  originalFileName: string;
  contentType: string;
  sizeBytes: number | null;
  widthPx: number | null;
  heightPx: number | null;
  etag: string | null;
  previewUrl: string | null;
  renditions: RenditionViewModel[];
}

export interface AttachmentViewModel {
  attachmentId: number;
  fileId: number;
  role: MediaRole;
  roleCode?: MediaRoleCode;
  sortOrder: number;
  title: string | null;
  altText: string | null;
  caption: string | null;
  publish: boolean;
  publishRequestedAt: string | null;
  publicDeliveryStatus?: PublicDeliveryStatus;
  file: AttachmentFileViewModel;
}

export interface MediaAttachmentsOwnerViewModel {
  defaultMediaFolderId: number;
  attachments: AttachmentViewModel[];
  currentVersions: MediaAttachmentVersions;
}
